export default "__VITE_ASSET__fbyd083k__"